export const FETCH_ALL_SPORTS = 'FETCH_ALL_SPORTS'
export const FETCH_ALL_SPORTS_SUCCESS = 'FETCH_ALL_SPORTS_SUCCESS'
export const FETCH_ALL_SPORTS_ERROR = 'FETCH_ALL_SPORTS_ERROR'

export const UPDATE_CALCULATOR = 'UPDATE_CALCULATOR'
export const DISPLAY_VARIATIONS = 'DISPLAY_VARIATIONS'
export const UPDATE_COMPONENT_LIST = 'UPDATE_COMPONENT_LIST'

export const FETCH_SPORT_VARIANT = 'FETCH_SPORT_VARIANT'
export const FETCH_SPORT_VARIANT_SUCCESS = 'FETCH_SPORT_VARIANT_SUCCESS'
export const FETCH_SPORT_VARIANT_ERROR = 'FETCH_SPORT_VARIANT_ERROR'

export const FETCH_LOGISTICS_AMOUNT = 'FETCH_LOGISTICS_AMOUNT'
export const FETCH_LOGISTICS_AMOUNT_SUCCESS = 'FETCH_LOGISTICS_AMOUNT_SUCCESS'
export const FETCH_LOGISTICS_AMOUNT_ERROR = 'FETCH_LOGISTICS_AMOUNT_ERROR'

export const FETCH_DURATIONS = 'FETCH_DURATIONS'
export const FETCH_DURATIONS_SUCCESS = 'FETCH_DURATIONS_SUCCESS'
export const FETCH_DURATIONS_ERROR = 'FETCH_DURATIONS_ERROR'

export const UPDATE_CALCULATOR_PRICE = 'UPDATE_CALCULATOR_PRICE'

export const CREATE_ENQUIRY_SUCCESS = 'CREATE_ENQUIRY_SUCCESS'
export const CREATE_ENQUIRY_ERROR = 'CREATE_ENQUIRY_ERROR'

export const CLEAR_CALCULATOR = 'CLEAR_CALCULATOR'

export const FETCH_ALL_PROVINCES_SUCCESS = 'FETCH_ALL_PROVINCES_SUCCESS'
export const FETCH_ALL_PROVINCES_ERROR = 'FETCH_ALL_PROVINCES_ERROR'

export const CONTACT_MESSAGE_SUCCESS = 'CONTACT_MESSAGE_SUCCESS'
export const CONTACT_MESSAGE_ERROR = 'CONTACT_MESSAGE_ERROR'

export const FETCH_PRODUCT_SUCCESS = 'FETCH_PRODUCT_SUCCESS'
export const FETCH_PRODUCT_ERROR = 'FETCH_PRODUCT_ERROR'

export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS'
export const FETCH_PRODUCTS_ERROR = 'FETCH_PRODUCTS_ERROR'



// WEBPACK FOOTER //
// ./src/actions/types.js